var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/tick-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/tick-circle_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.4987 58.6666C47.1654 58.6666 59.1654 46.6666 59.1654 31.9999C59.1654 17.3333 47.1654 5.33325 32.4987 5.33325C17.832 5.33325 5.83203 17.3333 5.83203 31.9999C5.83203 46.6666 17.832 58.6666 32.4987 58.6666Z",
    stroke: "#1373E7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.168 32L28.7146 39.5467L43.8346 24.4534",
    stroke: "#1373E7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick_circle.c196e68201f1d79a0710e22927f61f21.svg";
export { ForwardRef as ReactComponent };